import React, { useEffect, useState } from 'react';
import './Loader.css';

const Loader = ({ text = 'Loading...' }) => {
  const [loaderContent, setLoaderContent] = useState(<div className="loader-overlay">
      <div className="loader-container">
        <div className="loader-spinner"></div>
        <div className="loader-text">{text}</div>
      </div>
    </div>) 

  useEffect(()=>{
    const timer = setTimeout(()=>{
      setLoaderContent('')
    },1000*120)

    return ()=>{
      clearTimeout(timer)
    }
  })
  return <>{loaderContent}</>
};

export default Loader; 